import { makeObservable, observable } from 'mobx';
import { z } from 'zod';
import type { RequireAllProps } from '../../../../../store/utils/Dto';
import type { AccountSaveMethod } from '../../types';
import Service, { type ServiceDto } from '../Service';

export default class BunnyStorage extends Service<BunnyStorageDto> {
  static Schema = z.object({
    apiPassword: z.string().min(1),
    apiRegion: z.string(),
    storageZoneName: z.string(),
  });

  apiPassword = '';
  apiRegion = '';
  storageZoneName = '';

  constructor(dto: BunnyStorageDto = {} as any, onSave?: AccountSaveMethod) {
    super(dto, onSave);

    makeObservable(this, {
      apiPassword: observable,
      apiRegion: observable,
      storageZoneName: observable,
    });

    Object.assign(this, dto);
  }

  toJSON(): RequireAllProps<BunnyStorageDto> {
    return {
      ...super.toJSON(),
      apiPassword: this.apiPassword,
      apiRegion: this.apiRegion || '',
      storageZoneName: this.storageZoneName,
    };
  }
}

export interface BunnyStorageDto extends ServiceDto {
  apiPassword?: string;
  apiRegion?: string;
  storageZoneName?: string;
}
